import { EnrichedRow } from "./derive";

/** Display labels for the investmentPayment field (mirrors columns.tsx). */
const INVESTMENT_PAYMENT_LABEL: Record<string, string> = {
  CLIENTE: "Cliente",
  TI_MEDIA_GROUP_SL: "Ti Media Group SL",
};

/**
 * A column that can be filtered with a multi-select dropdown.
 * `getValue` returns the raw filter value ("" when the row has no value),
 * `formatOption` maps that raw value to the label shown in the dropdown.
 */
export interface FilterFieldDef {
  key: string;
  label: string;
  getValue: (r: EnrichedRow) => string;
  formatOption: (value: string) => string;
  minWidth: number;
  /** Groups the options in the dropdown (e.g. briefings under their client). */
  groupBy?: (r: EnrichedRow) => string;
  /** Key of another field whose selection narrows these options. */
  narrowedBy?: string;
}

export const FILTER_FIELDS: FilterFieldDef[] = [
  {
    key: "companyName",
    label: "Cliente",
    getValue: (r) => r.companyName ?? "",
    formatOption: (v) => v,
    minWidth: 200,
  },
  {
    key: "briefingName",
    label: "Briefing",
    getValue: (r) => r.briefingName ?? "",
    formatOption: (v) => v,
    minWidth: 240,
    groupBy: (r) => r.companyName || "Sin cliente",
    narrowedBy: "companyName",
  },
  {
    key: "platform",
    label: "Plataforma",
    getValue: (r) => r.platform ?? "",
    formatOption: (v) => v,
    minWidth: 170,
  },
  {
    key: "briefingCampaignType",
    label: "Tipo Plataforma",
    getValue: (r) => r.briefingCampaignType ?? "",
    formatOption: (v) => v,
    minWidth: 170,
  },
  {
    key: "sourceId",
    label: "Source ID",
    getValue: (r) => r.sourceId ?? "",
    formatOption: (v) => v,
    minWidth: 170,
  },
  {
    key: "investmentPayment",
    label: "Quién paga",
    getValue: (r) => r.investmentPayment ?? "",
    formatOption: (v) => INVESTMENT_PAYMENT_LABEL[v] ?? v,
    minWidth: 170,
  },
];
